import { render } from "./showProcess.vue?vue&type=template&id=2cbf5ea0&scoped=true&lang=pug"
import script from "./showProcess.vue?vue&type=script&setup=true&lang=js"
export * from "./showProcess.vue?vue&type=script&setup=true&lang=js"

import "./showProcess.vue?vue&type=style&index=0&id=2cbf5ea0&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbf5ea0"]])

export default __exports__